const hairColours = [
    { id: '36', name: 'Blonde' },
    { id: '37', name: 'Light Brown' },
    { id: '38', name: 'Brown' },
    { id: '39', name: 'Dark Brown' },
    { id: '40', name: 'Auburn' },
    { id: '41', name: 'Red/Ginger' },
    { id: '42', name: 'Black' },
    { id: '43', name: 'Grey' },
    { id: '44', name: 'Greying' },
    { id: '45', name: 'White' },
    { id: '46', name: 'Multi Coloured' },
    { id: '154', name: 'Strawberry Blonde' },
    { id: '155', name: 'Dark Blonde' }
  ];

export default hairColours;



// WEBPACK FOOTER //
// ./src/data/hair-colours.js